import { CodeCerfa, getScenarioAtByCodes } from 'features/arretTravail/models/scenarii';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

export const useAffilieSchema = ({ store, hasContact }) => {
    const { t } = useTranslation();
    const requiredMessage = t('yup.validators.required');
    const displayNationality = getScenarioAtByCodes(store)?.cerfa === CodeCerfa.S6202;

    return Yup.object().shape({
        affilie: Yup.object().shape({
            gender: Yup.string().required(requiredMessage),
            lastname: Yup.string().required(requiredMessage),
            firstname: Yup.string().required(requiredMessage),
            birthDate: Yup.date().required(requiredMessage),
            registrationNumber: Yup.string(),
            SSNumber: Yup.string()
                .required(requiredMessage)
                .matches(/^\d{13}$/, 'Le numéro de sécurité sociale doit contenir exactement 13 chiffres'),
            SSkey: Yup.string()
                .required(requiredMessage)
                .matches(/^\d{2}$/, 'La clé doit contenir exactement 2 chiffres'),
            regimeCod: Yup.string().required(requiredMessage),
            childNbr: Yup.string().required(requiredMessage),
            nationalityCod: displayNationality ? Yup.string().nullable().required(requiredMessage) : Yup.string().nullable(),
            famillyStatusCod: Yup.string().required(requiredMessage),
            email: hasContact ? Yup.string().email('Adresse email invalide') : Yup.string(),
            phone: hasContact ? Yup.string().matches(/^[0-9]{10}$/, 'Numéro de téléphone invalide') : Yup.string(),
            address: Yup.string().nullable(),
            addressCplt: Yup.string().nullable(),
            postalCode: Yup.string().nullable(),
            city: Yup.string().nullable(),
            qualificationCod: Yup.string().nullable().required(requiredMessage),
            hireDate: Yup.date().required(requiredMessage),
            statusCod: Yup.string().required(requiredMessage),
            coefHierarchi: Yup.string(),
            vrp: Yup.boolean(),
            job: Yup.object().shape({
                partimeEmployee: Yup.boolean(),
            }),
        }),
    });
};
